import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const logos = [
  "/clientLogo/1.png",
  "/clientLogo/2.png",
  "/clientLogo/3.png",
  "/clientLogo/4.png",
  "/clientLogo/5.png",
  "/clientLogo/6.jpg",
  "/clientLogo/7.png",
  "/clientLogo/8.png",
  "/clientLogo/9.jpg",
  "/clientLogo/10.jpg",
  "/clientLogo/11.jpg",
  "/clientLogo/12.jpg",
  "/clientLogo/13.png",
  "/clientLogo/14.png",
  "/clientLogo/15.png",
  "/clientLogo/16.png",
  "/clientLogo/17.png",
  "/clientLogo/18.png",
  "/clientLogo/19.png",
  "/clientLogo/20.png",
  "/clientLogo/21.png",
  "/clientLogo/22.png",
  "/clientLogo/23.jpg",
  "/clientLogo/24.png",
  "/clientLogo/25.jpg",
  "/clientLogo/26.jpg",
  "/clientLogo/27.jpg",
  "/clientLogo/28.jpg",
];

const Gsap = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    // Smooth infinite scroll animation
    const loop = gsap.to(container, {
      x: "-50%",
      duration: 32, // Slower duration (30s) keeps the colors from feeling "busy"
      ease: "none",
      repeat: -1,
    });
    return () => loop.kill();
  }, []);

  return (
    <div className="relative overflow-hidden w-full py-20 bg-[#0B0F19]">
      {/* Side Fades - These help colorful logos "emerge" from the dark edges */}
      <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#0B0F19] via-[#0B0F19]/80 to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-[#0B0F19] via-[#0B0F19]/80 to-transparent z-10" />

      <div ref={containerRef} className="flex w-max items-center gap-24 px-8">
        {/* Double the array for a seamless loop */}
        {[...logos, ...logos].map((logo, index) => (
          <div
            key={index}
            className="flex items-center justify-center pointer-events-none" // pointer-events-none ensures no cursor interaction
          >
            <img
              src={logo}
              alt="Client Logo"
              /* 1. Removed 'grayscale' to show original colors
                 2. Set 'opacity-100' for full visibility
                 3. Removed all 'hover:' classes
              */
              className="h-14 md:h-20 w-auto opacity-100 object-contain brightness-110 contrast-110"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gsap;
